module.exports = __webpack_public_path__ + "img/ac5.0e79c7e1.png";